import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Typography } from 'seagull';
import { routes } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import { formatNumericUSDate } from '~/utils';
const ViewInvoice = (param)=>{
    let { relationshipID, date, testId } = param;
    const { t: texts } = useLocaleKeys('pages.reports');
    return /*#__PURE__*/ _jsx(Typography, {
        as: Link,
        to: "".concat(routes.billingHub(relationshipID), "?selectedDate=").concat(formatNumericUSDate(date)),
        testId: testId,
        variant: "paragraph1",
        noWrap: true,
        ellipsis: true,
        children: texts.viewInvoice()
    });
};
export default ViewInvoice;
